var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerlinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45382 31C2.57416 30.2646 1.75351 29.4613 1 28.598L12.2594 18.1787C12.5768 17.6993 12.8161 17.1703 12.9664 16.6112L13.0116 16.4427L6.42819 15.466C5.65623 15.3515 5.65623 14.2406 6.42819 14.1259L12.3083 13.2537L5.50071 4.08753C5.03597 3.46179 5.8232 2.67614 6.45019 3.13995L15.6372 9.93579L16.5121 4.06242C16.6268 3.292 17.74 3.292 17.8547 4.06244L18.7289 9.93152L27.9102 3.13995C28.5372 2.67614 29.3245 3.46179 28.8598 4.08753L22.0527 13.253L27.9387 14.1259C28.7105 14.2406 28.7105 15.3515 27.9387 15.466L22.0527 16.3391L28.8598 25.5045C29.3245 26.1302 28.5372 26.9159 27.9102 26.4521L18.7289 19.6606L17.8547 25.5297C17.74 26.3 16.6268 26.3 16.5121 25.5295L15.5329 18.9554L14.9777 19.1039C14.6683 19.1867 14.3758 19.3182 14.1107 19.4923L3.45382 31Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerlinWhite);
export default __webpack_public_path__ + "static/media/merlin-white.43342c12c476ffd7b50cbb8ca4dacfc0.svg";
export { ForwardRef as ReactComponent };